/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSecurityHubFindingProductNameResponse {
    getFixupPrototypeFunction() { return AwsSecurityHubFindingProductNameResponse.fixupPrototype; }

    static newInstance(model: Partial<AwsSecurityHubFindingProductNameResponse>): AwsSecurityHubFindingProductNameResponse {
        let obj = Object.assign(new AwsSecurityHubFindingProductNameResponse(), model);
        AwsSecurityHubFindingProductNameResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSecurityHubFindingProductNameResponse>): AwsSecurityHubFindingProductNameResponse {
        if (!model) return null;
        return AwsSecurityHubFindingProductNameResponse.newInstance(<AwsSecurityHubFindingProductNameResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSecurityHubFindingProductNameResponse) {
        if (!obj) return;

        models.AwsSecurityHubFindingProductNameResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSecurityHubFindingProductNameResponse): boolean {
        Object.setPrototypeOf(obj, AwsSecurityHubFindingProductNameResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * List of Product Names
     */
    product_names: Array<string>;

}
